var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"shipment-history",class:{
		'warning': _vm.history && !_vm.history.isPlaceholder && !_vm.isDelivered,
		'danger': _vm.history && !_vm.history.isPlaceholder && _vm.dangerStatuses.includes(_vm.history.status),
		'active': _vm.history && !_vm.history.isPlaceholder && _vm.isDelivered,
	}},[_c('i',{staticClass:"shipment-history-icon material-icons"},[_vm._v(_vm._s(_vm.icon))])])}
var staticRenderFns = []

export { render, staticRenderFns }